import React from 'react';
import ReactDOM from 'react-dom/client';
import './glitchtip';
import './index.css';
import App from './App';
import { CartProvider } from './context/CartContext';
import { NotificationProvider } from './context/NotificationContext';
import axios from 'axios';

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NotificationProvider>
    <CartProvider>
      <App />
    </CartProvider>
  </NotificationProvider>
);
